import { createFileRoute, redirect } from '@tanstack/react-router';
import { STUDENT_TYPES } from '@/admin/people/profileTypes';

export const Route = createFileRoute('/admin/students/')({
  staticData: { minTier: 'FRONT_END_SUPPORT' },
  beforeLoad: () => {
    throw redirect({
      to: '/admin/people/',
      search: { filters: { profile_type: [...STUDENT_TYPES] } },
    });
  },
});
